__webpack_require__.p = "/wp-content/themes/a8c/host-partner-portal/";